var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{attrs:{"placeholder":_vm.placeholder,"options":_vm.plus?_vm.regionDataPlus:_vm.option,"size":"large","filterable":""},model:{value:(_vm.binds),callback:function ($$v) {_vm.binds=$$v},expression:"binds"}})
}
var staticRenderFns = []

export { render, staticRenderFns }